import Cookies from "js-cookie";
import {fileUrl, routes, useGetDataById, useRefreshData} from "../routes/api";
import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {
    createSearchParams,
    Link as RouterLink,
    useLocation,
    useNavigate,
    useOutletContext,
    useParams
} from "react-router-dom";
import {BEIssueComponent, LoadingComponent} from "../util/loading";
import {
    Alert,
    AlertTitle,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    CardMedia,
    Collapse,
    Grid,
    IconButton
} from "@mui/material";
import Typography from "@mui/material/Typography";
import {
    generateImageName,
    OverflowTooltip,
    sleep,
    toHumanReadableTime,
    updateConfirmationMessage,
    updateData,
} from "../util/util";
import Button from "@mui/material/Button";
import RefreshIcon from '@mui/icons-material/Refresh';
import HideImageIcon from '@mui/icons-material/HideImage';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import {
    AIModelRelationHeaders,
    CameraHeaders,
    CaptureSettingsDefaultFields,
    CaptureSettingsHeaders,
    CaptureSettingsPicFields,
    CaptureSettingsVidFields
} from "../util/getFields";
import ContentDetail from "../components/contentDetail";
import PopupDialog from "../components/popupDialog";
import RelationEdit from "../components/relationEdit";
import {aiModelFields, cameraFields, captureSettingsFields} from "../util/modelFields";
import {DeleteComponent} from "../components/confirmationDialog";
import Tooltip from "@mui/material/Tooltip";
import NavigateBreadcrumbs from "../components/navBreadcrumbs";
import ErrorDisplay from "../components/errorDisplay";
import {grey} from "@mui/material/colors";
import StatusList from "../components/statusList";
import WaitTimeStatus from "../components/waitTimeStatus";
import {EnumContext} from "../components/enumContext";
import DownloadIcon from '@mui/icons-material/Download';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import CaptureSettings from "../components/captureSettings";
import DeviceSettings from "../components/deviceSettings";
import RTSPLink from "../components/rtspLink";
import TrafficCountChart from "../components/dashboard/trafficCountChart";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import {ImagePopUpModal} from "../components/image";


export default function CameraDetail() {
    const token = Cookies.get('token');
    const permissions = Cookies.get('permissions') ?
        JSON.parse(Cookies.get('permissions')).unit :
        {create: false, edit: false, delete: false, view: false};
    const webAdmin = Cookies.get('webAdmin') === 'T';
    const {id} = useParams();
    const route = routes.camera;
    const {enums} = useContext(EnumContext);

    const [backendIssue, setBackendIssue] = useState(false);
    const [snackbarList, setSnackbarList] = useState([]);
    const [newData, setNewData] = useState({});
    const [noImage, setNoImage] = useState(false);
    const [editCaptureSettings, setEditCaptureSettings] = useState(false);
    const [cameraSettingsOpen, setCameraSettingsOpen] = useState(false);
    const [imageSize, setImageSize] = useState({});

    const [refreshing, setRefreshing] = useState(false);
    const [refreshAvl, setRefreshAvl] = useState(true);
    const [refreshError, setRefreshError] = useState(false);

    const [deleteError, setDeleteError] = useState({error: false, message: null, status: null});
    // const [modalOpen, setModalOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    const [popup, setPopup] = useState({
        'aimodel': false,
        'cameraproperty': false,
    })
    const [openCaptureSettings, setOpenCaptureSettings] = useState(false);
    const [openRTSPTab, setOpenRTSPTab] = useState(false);

    const [cameraAutoRefresh, setCameraAutoRefresh] = useOutletContext();

    const {data: detail, loading, statusCode: getStatus, handleCall} = useGetDataById(token, route, id);

    const {statusCode: refreshStatus, handleCall: refreshCall} = useRefreshData(token, route, id);

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from ? location.state.from : {pathname: `/`};

    const unitId = location.state?.unitId ? location.state.unitId : null;
    const unitSN = location.state?.unitSN ? location.state.unitSN : null;
    const page = location.state?.page ? location.state.page : null;
    const [imageSrc, setImageSrc] = useState('');
    const [dashboardParams, setDashboardParams] = useState('');

    useEffect(() => {
        if (getStatus >= 400 && getStatus < 500) {
            // navigate('/camera');
            navigate('/unit');
        } else if (getStatus >= 500) {
            setBackendIssue(true);
        }
    }, [getStatus]);

    const addSnackbar = (field, model, time) => {
        const id = new Date().getTime();
        setSnackbarList((prevSnackbars) => [
            ...prevSnackbars,
            {id, field, model, time},
        ]);
    };

    const handleClose = (id, event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarList((prevSnackbars) => prevSnackbars.filter((snackbar) => snackbar.id !== id));
    };

    const handleAIModelClick = (aimodel) => {
        navigate(`/aimodel/${aimodel}`, {
            state: {
                from: location,
                unitSN: unitSN,
                unitId: unitId,
                cameraSN: newData.data.c_sn,
                cameraId: id,
                page: page
            }
        });
    }

    // const handleModal = () => {
    //     setModalOpen((m) => !m);
    // }

    const handleDownloadImage = () => {
        const link = document.createElement("a");
        link.href = imageSrc;
        link.download = generateImageName(newData.data.c_sn, newData.image.time);
        link.type = newData.image.mimetype;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleRefresh = async () => {
        try {
            setRefreshing(true);
            setRefreshAvl(false);
            await refreshCall({body: {type: 'IMG'}});
            if (refreshStatus < 300) {
                await sleep(4000);
                addSnackbar('Refreshing', 'Camera', '2 minutes')
                await handleCall({});
            } else {
                setRefreshError(true);
            }
            setRefreshing(false);
            setRefreshAvl(true);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        let interval;
        if (cameraAutoRefresh) {
            fetchDetail();
            interval = setInterval(() => {
                fetchDetail();
            }, 120000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [cameraAutoRefresh]);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         handleRefresh();
    //     }, 1800000);
    //
    //     return () => clearInterval(interval);
    // }, []);

    const fetchDetail = async () => {
        try {
            await handleCall({});
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handlePopupClose = (key) => {
        setPopup({...popup, [key]: false});
    }

    // const handleSetAutoRefresh = (e) => {
    //     e.preventDefault();
    //     setCameraAutoRefresh(e.target.checked);
    //     sessionStorage.setItem('refresh', e.target.checked ? 'T' : 'F')
    // }

    useLayoutEffect(() => {
        if (!(permissions.view || webAdmin)) {
            navigate(from);
        } else {
            fetchDetail();
        }
    }, []);

    useEffect(() => {
        if (JSON.stringify(detail) !== '{}') {
            // && filterTime(record, timeDiff)
            const updatedData = updateData(detail.data, CameraHeaders, 'c', enums);
            const updatedAIModel = updateData(detail.AIModel, AIModelRelationHeaders, 'am',);
            const updatedConfirmationMessage = updateConfirmationMessage(detail.ConfirmationMessage);
            const updatedCaptureSettings = updateData(detail.CaptureSettings, CaptureSettingsHeaders, 'cs', enums);
            let filteredCaptureSettings;
            if (updatedCaptureSettings.cs_picEnable && updatedCaptureSettings.cs_vidEnable) {
                filteredCaptureSettings = updatedCaptureSettings;
            } else if (updatedCaptureSettings.cs_picEnable) {
                filteredCaptureSettings = Object.fromEntries(Object.entries(updatedCaptureSettings).filter(([key, _]) => CaptureSettingsDefaultFields.includes(key) || CaptureSettingsPicFields.includes(key)));
            } else if (updatedCaptureSettings.cs_vidEnable) {
                filteredCaptureSettings = Object.fromEntries(Object.entries(updatedCaptureSettings).filter(([key, _]) => CaptureSettingsDefaultFields.includes(key) || CaptureSettingsVidFields.includes(key)));
            } else {
                filteredCaptureSettings = Object.fromEntries(Object.entries(updatedCaptureSettings).filter(([key, _]) => CaptureSettingsDefaultFields.includes(key)));
            }
            setNewData({
                ...detail,
                data: updatedData,
                AIModel: updatedAIModel,
                ConfirmationMessage: updatedConfirmationMessage,
                CaptureSettings: filteredCaptureSettings,
                url: detail.url,
            });
            (detail.image && detail.image.file) ? setNoImage(false) : setNoImage(true);
        }
    }, [detail]);


    useEffect(() => {
        if (newData?.data?.c_sn) setDashboardParams(createSearchParams({cameraSN: newData.data.c_sn}).toString());
        if (!newData?.image?.file) return;
        const fetchImage = async () => {
            const response = await fetch(fileUrl(newData.image.file), {
                headers: {
                    'Authorization': `Token ${token}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                setImageSrc(objectUrl);

                const img = new Image();
                img.src = objectUrl;
                img.onload = () => {
                    setImageSize({width: img.naturalWidth, height: img.naturalHeight});
                };
            } else {
                setNoImage(true);
            }
        };

        fetchImage();

        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    }, [newData]);

    if (backendIssue) return <BEIssueComponent/>;
    if (loading || Object.keys(newData).length === 0) return <LoadingComponent/> // || recordLoading

    return (
        <Grid container spacing={2} alignItems="stretch" justifyContent="center"
              sx={{margin: 'auto', mt: 5, width: '80%'}}>
            <Grid size={12}>
                <Collapse in={refreshError}>
                    <Alert severity="error"
                           action={
                               <IconButton
                                   aria-label="close"
                                   color="inherit"
                                   size="small"
                                   onClick={() => {
                                       setRefreshError(false);
                                   }}
                               >
                                   <CloseIcon fontSize="inherit"/>
                               </IconButton>
                           }
                           sx={{mb: 2}}
                    >
                        <AlertTitle>Error</AlertTitle>
                        Couldn't refresh at the time. Please try again later.
                    </Alert>
                </Collapse>
                <ErrorDisplay
                    fields={cameraFields}
                    alert={deleteError.error}
                    setAlert={(alert) => setDeleteError({...deleteError, error: alert})}
                    response={deleteError.message}
                    statusCode={deleteError.status}
                />
                <WaitTimeStatus
                    snackbarList={snackbarList}
                    handleClose={handleClose}
                />
            </Grid>
            <Grid size={12}>
                <NavigateBreadcrumbs
                    alias='camera'
                    display='Camera'
                    id={newData.data.c_sn}
                    unitId={unitId}
                    unitSN={unitSN}/>
            </Grid>
            <Grid size={7} sx={{mb: 3}}>
                <Typography variant='h4'>Camera {newData.data.c_sn}</Typography>
            </Grid>
            <Grid size={5} key="refresh"
                  sx={{mt: 3.75, display: "flex", justifyContent: "flex-end"}}>
                <Button variant="outlined" onClick={handleRefresh} startIcon={<RefreshIcon/>}
                        disabled={!refreshAvl}>Fetch Data from Camera</Button>
            </Grid>
            <Grid size={{xs: 4, sm: 3, lg: 2}}>
                {(permissions.delete || webAdmin) &&
                    <DeleteComponent
                        alias='camera'
                        id={id}
                        navigate={navigate}
                        setError={setDeleteError}
                    />}
            </Grid>
            <Grid size={{xs: 8, sm: 9, lg: 10}} sx={{display: "flex", justifyContent: "flex-end"}}>
                {/*{newData.url ?*/}
                {/*    <Button variant="contained" startIcon={<VideoCameraBackIcon/>} onClick={() => setOpenRTSPTab(true)}>*/}
                {/*        Get RTSP video link*/}
                {/*    </Button> :*/}
                {/*    <Tooltip title='No address available for current camera'>*/}
                {/*        <span>*/}
                {/*            <Button variant="contained" disabled startIcon={<VideoCameraBackIcon/>}>*/}
                {/*    Get RTSP video link*/}
                {/*</Button>*/}
                {/*        </span>*/}
                {/*    </Tooltip>*/}
                {/*}*/}
                <Button
                    variant='contained'
                    startIcon={<OpenInNewIcon/>}
                    component={RouterLink}
                    to={{pathname: `/camera/${id}/dashboard`, search: `?${dashboardParams}`}}

                    state={{
                        from: location,
                        unitSN: unitSN,
                        unitId: unitId,
                        cameraSN: newData.data.c_sn,
                        cameraId: id,
                        page: page
                    }}
                    target="_blank" rel="noopener"
                    sx={{ml: 1}}>
                    Open Camera Dashboard
                </Button>
            </Grid>
            <Grid size={12} sx={{mb: 5, display: "flex", justifyContent: "flex-end"}}>
                {(permissions.edit || webAdmin) &&
                    <Button variant="contained" onClick={() => setCameraSettingsOpen(true)}
                            startIcon={<SettingsApplicationsIcon/>}>
                        View/Update Camera Settings
                    </Button>}

            </Grid>
            {refreshing &&
                <Grid
                    size={12}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <CircularProgress/>
                </Grid>
            }
            <DeviceSettings
                route='Camera'
                open={cameraSettingsOpen}
                setOpen={setCameraSettingsOpen}
                deviceId={id}
                image={imageSrc}
                imageSize={imageSize}
            />
            <Grid size={12} key="camera-detail" sx={{display: 'flex'}}>
                <Card sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                    <CardHeader
                        action={(permissions.edit || webAdmin) ?
                            <IconButton onClick={() => setEdit(!edit)}>
                                <EditIcon/>
                            </IconButton> :
                            null
                        }
                        title='Details'
                    />
                    <CardContent>
                        <ContentDetail
                            alias='camera'
                            id={id}
                            data={newData.data}
                            edit={edit}
                            setEdit={setEdit}
                            refresh={fetchDetail}
                            fields={cameraFields}
                        />
                        <StatusList data={newData.ConfirmationMessage}/>
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={{xs: 12, lg: 6}} key="capture-settings" sx={{display: 'flex'}}>
                <Card sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                    <CardHeader
                        action={(permissions.edit || webAdmin) ?
                            <IconButton onClick={() => (setOpenCaptureSettings(true))}>
                                <EditIcon/>
                            </IconButton> :
                            null
                        }
                        title="Image/Video Capture Settings"/>
                    <CardContent>
                        <ContentDetail
                            alias='camera'
                            id={id}
                            data={newData.CaptureSettings}
                            edit={editCaptureSettings}
                            setEdit={setEditCaptureSettings}
                            refresh={fetchDetail}
                            fields={captureSettingsFields}
                            viewOnly
                        />
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={{xs: 12, lg: 6}} key="properties" sx={{display: 'flex'}}>
                <Card sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                    <CardHeader
                        action={(permissions.edit || webAdmin) ?
                            <IconButton onClick={() => (setPopup({...popup, cameraproperty: true}))}>
                                <EditIcon/>
                            </IconButton> :
                            null
                        }
                        title="Additional Information"/>
                    {newData.CameraProperty.length === 0 ?
                        <CardContent>
                            <IconButton disableRipple>
                                <FormatListBulletedIcon sx={{fontSize: 50}}/>
                            </IconButton>
                            <Typography variant="caption" color="grey">
                                No additional information
                            </Typography>
                        </CardContent> :
                        <CardContent>
                            <Grid container
                                  spacing={1}
                                  sx={{margin: 'auto', mb: 2}}
                                  alignItems="center"
                                  justifyContent="center"
                            >
                                {newData.CameraProperty.map(([, [key, value, desc]]) => (
                                    [
                                        <Grid size={5} key={key} sx={{mb: 1}}>
                                            <Tooltip title={desc} arrow>
                                                <Typography variant="body1" color={grey[700]}>
                                                    {key}
                                                </Typography>
                                            </Tooltip>
                                        </Grid>,
                                        <Grid size={7} key={`${key}-value`} sx={{mb: 1}}>
                                            <Tooltip title={desc} arrow placement="bottom-start">
                                                <Typography variant="body1">
                                                    {value}
                                                </Typography>
                                            </Tooltip>
                                        </Grid>
                                    ]
                                ))}
                            </Grid>
                        </CardContent>}
                </Card>
            </Grid>
            <Grid size={{xs: 12, lg: 6}} key="camera-model" sx={{display: 'flex'}}>
                <Card sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                    <CardHeader
                        action={webAdmin ?
                            <IconButton onClick={() => (setPopup({...popup, aimodel: true}))}>
                                <EditIcon/>
                            </IconButton> :
                            null
                        }
                        title='AI Model'
                    />
                    {Object.keys(newData.AIModel).length === 0 ?
                        <CardContent>
                            <IconButton disableRipple>
                                <FormatListBulletedIcon sx={{fontSize: 50}}/>
                            </IconButton>
                            <Typography variant="caption" color="grey">
                                No Related AI Model
                            </Typography>
                        </CardContent> :
                        <CardContent>
                            <CardActionArea onClick={webAdmin ? () => (handleAIModelClick(detail.AIModel.id)) : null}>
                                <Grid container
                                      spacing={1}
                                      sx={{margin: 'auto', mb: 2}}
                                      alignItems="center"
                                      justifyContent="center"
                                >
                                    {Object.entries(newData.AIModel).filter((item) => (item[0] !== 'id')).map(([key, value]) => (
                                        [
                                            <Grid size={5} key={key} sx={{mb: 1}}>
                                                <Typography variant="body1" color={grey[700]}>
                                                    {aiModelFields.fields[key].display || key}
                                                </Typography>
                                            </Grid>,
                                            <Grid size={7} key={`${key}-value`} sx={{mb: 1}}>
                                                <OverflowTooltip followCursor>
                                                    <Typography variant="body1">
                                                        {value}
                                                    </Typography>
                                                </OverflowTooltip>
                                            </Grid>
                                        ]
                                    ))}
                                </Grid>
                            </CardActionArea>
                        </CardContent>
                    }
                </Card>
            </Grid>
            {/*<PopupDialog*/}
            {/*    open={openRTSPTab}*/}
            {/*    display="RTSP Link"*/}
            {/*    content={<RTSPLink id={id}/>}*/}
            {/*    handleClose={() => setOpenRTSPTab(false)}*/}
            {/*/>*/}
            <PopupDialog
                open={popup.cameraproperty}
                content={<RelationEdit
                    fields={cameraFields}
                    alias='camera'
                    display='Camera'
                    id={id}
                    relation='CameraProperty'
                    refresh={fetchDetail}
                    addSnackbar={addSnackbar}
                    defaultValue={newData.CameraProperty.map(([id, [key, value]]) => ([id, `${key}: ${value}`]))}
                    setEdit={(value) => (setPopup({...popup, cameraproperty: value}))}
                />}
                handleClose={() => handlePopupClose('cameraproperty')}
            />
            <PopupDialog
                key='model-popup'
                open={popup.aimodel}
                content={<RelationEdit
                    fields={cameraFields}
                    alias='camera'
                    display='Camera'
                    id={id}
                    relation='AIModel'
                    refresh={fetchDetail}
                    addSnackbar={addSnackbar}
                    defaultValue={
                        Object.keys(newData.AIModel).length === 0 ?
                            null :
                            [newData.AIModel.id, `${newData.AIModel.am_name} (${newData.AIModel.am_version})`]
                    }
                    setEdit={(value) => (setPopup({...popup, aimodel: value}))}
                />}
                handleClose={() => handlePopupClose('aimodel')}
            />
            <CaptureSettings
                open={openCaptureSettings}
                setOpen={setOpenCaptureSettings}
                data={detail.CaptureSettings}
                cameraId={detail.data.id}
                refresh={fetchDetail}
            />
            <Grid size={{xs: 12, lg: 6}} key="image">
                {noImage ?
                    <Card key='no-image-card'
                          sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                        <CardHeader title="Recent Image"/>
                        <CardContent>
                            <IconButton disableRipple>
                                <HideImageIcon sx={{fontSize: 50}}/>
                            </IconButton>
                            <Typography variant="caption" color="grey">
                                Image not Available
                            </Typography>
                        </CardContent>
                    </Card>
                    : [
                        <Card key='image-card'
                              sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                            <CardHeader
                                title="Recent Image"
                                action={
                                    <IconButton onClick={handleDownloadImage}>
                                        <DownloadIcon/>
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Grid container
                                      spacing={1}
                                      sx={{margin: 'auto'}}
                                      alignItems="center"
                                      justifyContent="center"
                                >
                                    <Grid size={3} key='refresh-key'>
                                        <Typography variant="body1" color={grey[700]}>
                                            Time Taken
                                        </Typography>
                                    </Grid>
                                    <Grid size={9} key='refresh-value'>
                                        <Typography variant="body1">
                                            {newData.image ? toHumanReadableTime(newData.image.time).datetimeStr : "N/A"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                            {newData.url ?
                                <CardActionArea
                                    component="a"
                                    // disabled={!newData.url}
                                    disabled
                                    href={newData.c_order === '1' ? newData.url + ':7080' : newData.url + ':8080'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{mb: 2}}>
                                    <CardMedia
                                        component="img"
                                        image={imageSrc}
                                        alt={newData.image.time}
                                    />
                                </CardActionArea> :
                                <CardMedia
                                    component="img"
                                    image={imageSrc}
                                    alt={newData.image.time}
                                />
                            }
                        </Card>
                        // <ImagePopUpModal
                        //     key='image-popup'
                        //     img={imageSrc}
                        //     open={modalOpen}
                        //     setOpen={setModalOpen}
                        //     currentPoints={detail.data.c_coordinates}
                        //     alt={newData.image.time}
                        //     id={id}
                        //     addSnackbar={addSnackbar}
                        //     refresh={fetchDetail}
                        // />
                    ]
                }
            </Grid>
            <Grid size={12} key="chart" sx={{mt: 2, minHeight: 400}}>
                <TrafficCountChart cameraId={id} title='Recent Traffic Data'/>
            </Grid>
        </Grid>
    );
}